import ButtonSkeleton from '../../../../../components/Button/skeleton';

const DeletePollSkeleton = () => {
  // oversizing the button to look good
  return <ButtonSkeleton size="small" width={34} height={34} />;
};

export default DeletePollSkeleton;
